import React, { useState } from 'react';
import QuotationForm from './QuotationForm';
import QuotationPreview from './QuotationPreview';
import axios from 'axios';

// Configure API base URL
const API_BASE_URL = process.env.REACT_APP_API_URL + '/api';

function Quotation() {
    const [formData, setFormData] = useState({
        quoteNo: '',
        date: new Date().toLocaleDateString('en-GB'),
        client: '',
        phone: '',
        location: '',
        from: {
            company: 'PRIMEDALE TOURS & TRAVEL',
            phone: '+254745715136',
            address: 'VIEWPARK TOWERS, UTALII LANE'
        },
        footer: {
            email: 'info@primedaletours.com',
            website: 'www.primedaletours.com',
            phone: '+254745715136',
            tagline: 'Precision in Every Journey'
        },
        options: [
            {
                sl: '1',
                name: '',
                amount: '',
                description: ''
            }
        ],
        inclusives: [''],
        exclusives: ['']
    });

    const [showPreview, setShowPreview] = useState(false);
    const [isGenerating, setIsGenerating] = useState(false);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [error, setError] = useState(null);
    const [currentDraftId, setCurrentDraftId] = useState(null);
    const token = localStorage.getItem('token');

    const handleInputChange = (section, field, value, index = null) => {
        if (section === 'options' && index !== null) {
            const newOptions = [...formData.options];
            newOptions[index] = { ...newOptions[index], [field]: value };
            setFormData({ ...formData, options: newOptions });
        } else if (section === 'inclusives' && index !== null) {
            const newInclusives = [...formData.inclusives];
            newInclusives[index] = value;
            setFormData({ ...formData, inclusives: newInclusives });
        } else if (section === 'exclusives' && index !== null) {
            const newExclusives = [...formData.exclusives];
            newExclusives[index] = value;
            setFormData({ ...formData, exclusives: newExclusives });
        } else if (section === 'from') {
            setFormData({
                ...formData,
                from: { ...formData.from, [field]: value }
            });
        } else if (section === 'footer') {
            setFormData({
                ...formData,
                footer: { ...formData.footer, [field]: value }
            });
        } else {
            setFormData({
                ...formData,
                [field]: value
            });
        }
    };

    const addOption = () => {
        setFormData({
            ...formData,
            options: [...formData.options, { sl: (formData.options.length + 1).toString(), name: '', amount: '', description: '' }]
        });
    };

    const removeOption = (index) => {
        const newOptions = formData.options.filter((_, i) => i !== index);
        newOptions.forEach((opt, i) => opt.sl = (i + 1).toString());
        setFormData({ ...formData, options: newOptions });
    };

    const addInclusive = () => {
        setFormData({
            ...formData,
            inclusives: [...formData.inclusives, '']
        });
    };

    const removeInclusive = (index) => {
        const newInclusives = formData.inclusives.filter((_, i) => i !== index);
        setFormData({ ...formData, inclusives: newInclusives });
    };

    const addExclusive = () => {
        setFormData({
            ...formData,
            exclusives: [...formData.exclusives, '']
        });
    };

    const removeExclusive = (index) => {
        const newExclusives = formData.exclusives.filter((_, i) => i !== index);
        setFormData({ ...formData, exclusives: newExclusives });
    };

    // Load draft data
    const handleLoadDraft = (draft) => {
        const draftId = draft.draft_id || draft.draftId || '';
        const quoteNo = draft.quote_no || draft.quoteNo || '';
        const date = draft.date || new Date().toLocaleDateString('en-GB');
        const clientName = draft.client_name || draft.clientName || '';
        const clientPhone = draft.client_phone || draft.clientPhone || '';
        const clientLocation = draft.client_location || draft.clientLocation || '';
        const fromCompany = draft.from_company || draft.fromCompany || 'PRIMEDALE TOURS & TRAVEL';
        const fromPhone = draft.from_phone || draft.fromPhone || '+254745715136';
        const fromAddress = draft.from_address || draft.fromAddress || 'VIEWPARK TOWERS, UTALII LANE';
        const footerEmail = draft.footer_email || draft.footerEmail || 'info@primedaletours.com';
        const footerWebsite = draft.footer_website || draft.footerWebsite || 'www.primedaletours.com';
        const footerPhone = draft.footer_phone || draft.footerPhone || '+254745715136';
        const footerTagline = draft.footer_tagline || draft.footerTagline || 'Precision in Every Journey';
        const options = draft.options || [];
        const inclusives = draft.inclusives || [''];
        const exclusives = draft.exclusives || [''];

        // Set all data at once
        setFormData({
            quoteNo: quoteNo,
            date: date,
            client: clientName,
            phone: clientPhone,
            location: clientLocation,
            from: {
                company: fromCompany,
                phone: fromPhone,
                address: fromAddress
            },
            footer: {
                email: footerEmail,
                website: footerWebsite,
                phone: footerPhone,
                tagline: footerTagline
            },
            options: options.length > 0 ? options : [{ sl: '1', name: '', amount: '', description: '' }],
            inclusives: inclusives.length > 0 ? inclusives : [''],
            exclusives: exclusives.length > 0 ? exclusives : ['']
        });

        setCurrentDraftId(draftId);
        alert('Draft loaded successfully!');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsGenerating(true);
        setError(null);

        // Validate required fields
        if (!formData.client || formData.client.trim() === '') {
            alert('Please enter client name');
            setIsGenerating(false);
            return;
        }

        const validOptions = formData.options.filter(opt => opt.name && opt.name.trim() !== '');
        if (validOptions.length === 0) {
            alert('Please add at least one service option');
            setIsGenerating(false);
            return;
        }

        // Prepare data for PDF generation
        const pdfData = {
            quoteNo: formData.quoteNo,
            date: formData.date,
            from: formData.from,
            to: {
                name: formData.client,
                phone: formData.phone,
                location: formData.location
            },
            footer: formData.footer,
            options: formData.options
                .filter(opt => opt.name.trim() !== '')
                .map(opt => ({
                    sl: opt.sl || '',
                    name: opt.name,
                    amount: parseFloat(opt.amount) || 0,
                    description: opt.description || ''
                })),
            inclusives: formData.inclusives.filter(item => item.trim() !== ''),
            exclusives: formData.exclusives.filter(item => item.trim() !== '')
        };

        try {
            const response = await axios.post(
                `${API_BASE_URL}/quotation/generate`,
                pdfData,
                {
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/pdf',
                        'Authorization': `Bearer ${token}`
                    }
                }
            );

            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            setPdfUrl(url);
            setShowPreview(true);
        } catch (error) {
            console.error('Error generating PDF:', error);

            if (error.response) {
                if (error.response.status === 404) {
                    setError('API endpoint not found. Please check if the backend server is running');
                } else if (error.response.status === 500) {
                    setError('Server error. Please check the backend logs for details.');
                } else {
                    setError(`Error: ${error.response.status} - ${error.response.statusText}`);
                }
            } else if (error.request) {
                setError('Cannot connect to the server. Please make sure the backend is running');
            } else {
                setError(`Request error: ${error.message}`);
            }

            alert(error.message || 'Error generating PDF. Please try again.');
        } finally {
            setIsGenerating(false);
        }
    };

    const handleDownload = () => {
        if (pdfUrl) {
            const link = document.createElement('a');
            link.href = pdfUrl;
            link.download = `${formData.client}_${formData.quoteNo || 'draft'}_${formData.date}.pdf`;
            link.click();
        }
    };

    const loadSampleData = () => {
        setFormData({
            quoteNo: 'QPD1126',
            date: '07/05/2026',
            client: 'John Doe',
            phone: '+254704760532',
            location: 'NAIROBI',
            from: {
                company: 'PRIMEDALE TOURS & TRAVEL',
                phone: '+254745715136',
                address: 'VIEWPARK TOWERS, UTALII LANE'
            },
            footer: {
                email: 'info@primedaletours.com',
                website: 'www.primedaletours.com',
                phone: '+254745715136',
                tagline: 'Precision in Every Journey'
            },
            options: [
                {
                    sl: 'Option 1',
                    name: 'Lazarus Lodge',
                    amount: '21000',
                    description: 'Per person sharing'
                },
                {
                    sl: 'Option 2',
                    name: 'Sebai Suites',
                    amount: '23000',
                    description: 'Per person sharing'
                },
                {
                    sl: 'Option 3',
                    name: 'Lake Naivasha Resort',
                    amount: '30000',
                    description: 'Per person sharing'
                }
            ],
            inclusives: [
                '2 Nights accommodation on half board in a standard double room',
                '2 Days conference inclusive of, conference hall, 10am tea, buffet lunch, 4pm tea, mineral water, stationery',
                'Access to hotel amenities'
            ],
            exclusives: [
                'Transport',
                'Activities and excursions'
            ]
        });
        setCurrentDraftId(null);
    };

    const clearForm = () => {
        if (!window.confirm('Clear all form fields?')) return;

        setFormData({
            quoteNo: '',
            date: new Date().toLocaleDateString('en-GB'),
            client: '',
            phone: '',
            location: '',
            from: {
                company: 'PRIMEDALE TOURS & TRAVEL',
                phone: '+254745715136',
                address: 'VIEWPARK TOWERS, UTALII LANE'
            },
            footer: {
                email: 'info@primedaletours.com',
                website: 'www.primedaletours.com',
                phone: '+254745715136',
                tagline: 'Precision in Every Journey'
            },
            options: [
                {
                    sl: '1',
                    name: '',
                    amount: '',
                    description: ''
                }
            ],
            inclusives: [''],
            exclusives: ['']
        });
        setCurrentDraftId(null);
    };

    return (
        <div className="quotation-generator">
            {!showPreview ? (
                <>
                    <div className="container-fluid py-5">
                        <div className="container">
                            <div className="text-center mb-5">
                                <h1 className="display-4 fw-bold" style={{ color: 'var(--primary)' }}>
                                    Generate Quotation
                                </h1>
                                <p className="text-muted">Create professional quotations for your clients</p>
                            </div>

                            <div className="d-flex justify-content-end gap-3 mb-4 flex-wrap">
                                <button onClick={loadSampleData} className="btn navyblue-bg text-white">
                                    <i className="fa fa-database me-2"></i>Load Sample Data
                                </button>
                                <button onClick={clearForm} className="btn btn-danger">
                                    <i className="fa fa-trash me-2"></i>Clear Form
                                </button>
                            </div>

                            {error && (
                                <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                    <strong>Error:</strong> {error}
                                    <button type="button" className="btn-close" data-bs-dismiss="alert" onClick={() => setError(null)}></button>
                                </div>
                            )}

                            <QuotationForm
                                formData={formData}
                                onInputChange={handleInputChange}
                                onAddOption={addOption}
                                onRemoveOption={removeOption}
                                onAddInclusive={addInclusive}
                                onRemoveInclusive={removeInclusive}
                                onAddExclusive={addExclusive}
                                onRemoveExclusive={removeExclusive}
                                onSubmit={handleSubmit}
                                isGenerating={isGenerating}
                                token={token}
                                currentDraftId={currentDraftId}
                                setCurrentDraftId={setCurrentDraftId}
                                onLoadDraft={handleLoadDraft}
                            />
                        </div>
                    </div>
                </>
            ) : (
                <QuotationPreview
                    pdfUrl={pdfUrl}
                    onBack={() => setShowPreview(false)}
                    onDownload={handleDownload}
                    formData={formData}
                />
            )}
        </div>
    );
}

export default Quotation;